import React, { useState, useContext, useEffect } from 'react';
import { Popover } from 'antd';
import { CenterConsole } from './components/index.js';
import { useComment, CommentCtx } from './components/CommentProvider.js';
import { SocketContext } from './socketManager/SocketProvider';
import useAutoOpenCommentCenter from './components/useAutoOpenCommentCenter';
const CommentCenter = () => {
  const [isActive, setIsActive] = useState(false);
  const { socket } = useContext(SocketContext);
  const iconClass = isActive ? 'icon-comment-fill' : 'icon-comment-outline';
  const commentContextValue = useComment() || {};
  const content = (
    <CenterConsole
      isPanelActive={isActive}
      urlTabMap={commentContextValue.urlTabMap}
    />
  );

  useEffect(
    () => () => {
      if (socket && typeof socket.emit === 'function') {
        socket.emit('comment:leaveProject', {
          projectId: commentContextValue.projectId,
        });
      }
    },
    [],
  );

  useAutoOpenCommentCenter(setIsActive);

  return (
    <div className="comment-center-wrapper">
      <CommentCtx.Provider
        value={{ setPanelVisible: setIsActive, ...commentContextValue }}
      >
        <Popover
          content={content}
          trigger="click"
          visible={isActive}
          onVisibleChange={setIsActive}
          placement="bottomRight"
          getPopupContainer={() =>
            document.getElementsByClassName('app-header')[0] || document.body
          }
          overlayClassName="comment-center-popover"
        >
          {/* <MessageOutlined/> */}
          <span className={`appkiticon ${iconClass}`} />
        </Popover>
      </CommentCtx.Provider>
    </div>
  );
};

export default CommentCenter;
